export default __webpack_public_path__ + "static/media/pepper.539f3006.png";